import { syncPartnerAppTheme } from "../Pages/Public/partnerAppTheme";
import { loadBrandingSession } from "../Hooks/brandingStorage";
import {
  expectsPartnerBranding,
  isPartnerBrandOptions,
  resolveEffectiveBrandingHost,
} from "../Hooks/WhiteLabel";

/** Apply cached partner theme before React paint (prevents Valut flash on reload). */
export const hydrateBrandingFromSession = () => {  const host = resolveEffectiveBrandingHost();
  if (!host || !expectsPartnerBranding()) {
    return null;
  }

  const cached = loadBrandingSession(host);
  if (
    !cached ||
    !isPartnerBrandOptions(cached) ||
    String(cached.resolved_host || "").toLowerCase() !== host
  ) {
    return null;
  }

  syncPartnerAppTheme(cached);
  return cached;
};

export const hideAppBootLoader = () => {
  const loader = document.getElementById("app-boot-loader");
  if (loader) {
    loader.style.display = "none";
  }
  document.documentElement.classList.remove(
    "app-boot-loading",
    "app-boot-partner",
  );
};
